import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Button,
  Box,
} from "@mui/material";
import { Coach } from "../../model/entity/Coach";
import { Edit } from "@mui/icons-material";
import { OverviewFilterField } from "../../components/OverviewFilterField";
import { useNavigate } from "react-router-dom";
import handleAxiosError from "../../components/ErrorHandler";
import { notifErr } from "../../components/Functions";
import { getFetcher } from "../../components/Fetchers";

const CoachesOverview = () => {
  const [page, setPage] = useState(0);
  const [coaches, setCoaches] = useState<Coach[]>([]);
  const [totalElements, setTotalElements] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [filter, setFilter] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCoaches = async () => {
      const config = {
        search: filter,
        page: page,
        size: rowsPerPage,
      };
      try {
        const response = await getFetcher(
          `${process.env.REACT_APP_API_URL}/coaches/all`,
          config
        );
        setCoaches(response.data.content);
        setTotalElements(response.data.totalElements);
      } catch (err) {
        notifErr(handleAxiosError(err));
      }
    };

    fetchCoaches();
  }, [page, rowsPerPage, filter]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="tableContainer">
      <div className="aboveTableWrapper">
        <div>
          <Button
            className="submitBtn"
            onClick={() => navigate("/overview/coaches/add-new")}
          >
            Nový trenér
          </Button>
        </div>
        <div>
          <OverviewFilterField setFilter={setFilter} />
        </div>
      </div>
      <Paper
        className="tableContainer"
        elevation={coaches.length ? 1 : 0}
        sx={{ width: "70%", maxHeight: "48rem" }}
      >
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow className="tableHeader">
                <TableCell className="tableHeaderCell tableHeaderFirstCell" width={"22%"}>
                  Jméno
                </TableCell>
                <TableCell className="tableHeaderCell">Email</TableCell>
                <TableCell className="tableHeaderCell">Telefon</TableCell>
                <TableCell className="tableHeaderCell tableHeaderLastCell">
                  Akce
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {coaches.map((coach) => (
                <TableRow key={coach.id} className="tableRow">
                  <TableCell className="tableCell tableFirstCell">
                    {coach.firstName + " " + coach.lastName}
                  </TableCell>
                  <TableCell className="tableCell">{coach.email}</TableCell>
                  <TableCell className="tableCell">{coach.phone}</TableCell>
                  <TableCell
                    className="tableCell tableLastCell"
                    onClick={() => {
                      navigate(`/overview/coaches/edit/${coach.id}`);
                    }}
                  >
                    <Edit className="editBtn" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ backgroundColor: "white", width: "100%" }}>
          <TablePagination
            className="tablePagination"
            rowsPerPageOptions={[5, 10, 20, 999]}
            component="div"
            count={totalElements}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </Paper>
    </div>
  );
};

export default CoachesOverview;
